<template>
	<div class="prodictImageswap">
	<!-- v-model="slide"  -->
	<b-carousel id="carousel-1" :interval="intervalSlider" controls indicators  background="#dddddd" img-width="360px" img-height="400px" style="text-shadow: 1px 1px 2px #333;"
      :no-hover-pause=true >
                       <!--  <b-link href="/marketing/sales-advisor"> <b-carousel-slide :img-src="$root.MEDIAPATH+'banners/banner-sales-advisor.jpg'" class="homescrollImgHeight" ></b-carousel-slide></b-link> -->
						
                        <!--<b-carousel-slide  v-for="image in galleryimages" :key="image"   :img-src="$root.MEDIAAPI+'toolimage/get_image?size=360x400&src='+image" class="homescrollImgHeight expand" ></b-carousel-slide>-->
						
						<span  v-for="image in galleryimagesList" :key="image">
						 <b-carousel-slide v-if="image!='' && image!=null">
						<template #img >
						  <img
							
							width="360"
							height="400"
							:src="$root.MEDIAAPI+'toolimage/get_image?size=600x500&src='+image"
							alt="image slot"
							
							:class="[{'fullImage' : fullWidthImage}]" @click="fullWidthImage = !fullWidthImage"
						  >
						</template>
					  </b-carousel-slide>
					  </span>
						
                     
					
                       <!-- <b-carousel-slide :img-src="$root.MEDIAPATH+'banners/17a0e514-2928-418d-9050-f6e661a1ccab.jpg'"></b-carousel-slide>
						<b-carousel-slide :img-src="$root.MEDIAPATH+'banners/45c0461d-fb33-4a9f-b9fb-107d36c85153.jpg'"></b-carousel-slide>  -->
                    </b-carousel>
	
	
	
		
   </div>
    
</template>

<script>
//import AddtocartButton from "@/components/addtocartButton.vue";
export default {
  name: 'Quickview',
  props: {
    galleryimages: { type: Array }
  },
  components: {
  //"addtocart-button": AddtocartButton,
  },
  mounted(){
    //this.heading = "Related Products";
  },
  computed: {
   		 galleryimagesList: function () {
				return this.galleryimages.filter(el => {
				  return el != null && el != '';
				});
				//console.log(arrFiltered);
		}
  },
  data() {
  
    return{
		//thumbnailProps: { blank: false, fluidGrow: true, width: 360, height: 400,class: 'm1' },
		intervalSlider:0,
		 fullWidthImage: false,
    }
  },
  methods:{
		zoomMe(event){
		
		console.log('Zoom me'+event.width);
		}
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
	.prodictImageswap{
		margin-bottom: 27px;
		height:405px;
		.carousel-indicators {
			bottom: -50px;
			z-index: unset;
			width: 100%;
			margin-left: 0px;
			li{
				    width: 7px;
					height: 7px;
					 border-radius: 100%;
					 background-color: #000;
					 z-index: 0;
					 margin: 0px 6px;
				/* &:focus{ border:2px solid red;
				}*/
			}
			 
			.expand { width:23em;/* height: 25em;*/ border:1px solid red;}
			
			
		}
		
		.fullImage {
			  width: 200%;
			  height: auto;
			}
	
		/*.swiper-wrapper{
			.padding:0px;
			.swiper-slide{
				padding:0px;
				background-color: unset;
			}
		}
		.productigDisplay{
			max-width: 100%;
			height: 400px;
		} */
		
		.img-fluid{
		    max-width: 100%;
			height: 400px;
		}
		.w-100{
			width: auto !important;
		}
	}
	/*.swiper-priceinfo{
				min-height: 45px;
	}
			  
  .swiper-button-lock {
	display:block !important;
  } */

</style>
